import { render } from "./AzureADLoginButton.vue?vue&type=template&id=28b7e14e&scoped=true"
import script from "./AzureADLoginButton.vue?vue&type=script&lang=js"
export * from "./AzureADLoginButton.vue?vue&type=script&lang=js"

import "./AzureADLoginButton.vue?vue&type=style&index=0&id=28b7e14e&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b7e14e"],['__file',"src/components/AzureADLoginButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28b7e14e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28b7e14e', __exports__)) {
    console.log('reload')
    api.reload('28b7e14e', __exports__)
  }
  
  module.hot.accept("./AzureADLoginButton.vue?vue&type=template&id=28b7e14e&scoped=true", () => {
    console.log('re-render')
    api.rerender('28b7e14e', render)
  })

}


export default __exports__